import React, { useMemo } from "react";
import { useLSSearch } from "../LSSearch";
import { AddToListButton } from "../../../resource/AddToListButton";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";
import {
  isAdvancedSearchTerm,
  isReadingLevelSearch,
} from "../../advanced/AdvancedSearchTerm";

export const LSResultItemAddToListButton = ({
  resource,
  dense,
}: {
  dense?: boolean;
  resource: ResourceView | ResourceDWR;
}) => {
  const {
    searchParams: { term, rawTerm },
  } = useLSSearch();

  const defaultName = useMemo(
    () =>
      isAdvancedSearchTerm(rawTerm) || isReadingLevelSearch(rawTerm)
        ? ""
        : term,
    [rawTerm, term]
  );

  return (
    <AddToListButton
      resourceId={resource.id}
      defaultName={defaultName}
      dense={dense}
    />
  );
};
